import React from 'react';
import './style.css';
import useLocalization from '../../../Localization';

const Footer = () => {
  const {ApplicationString} = useLocalization();
  return (
    <div className='footer-container'>
      <div className='content'>
        <p>{ApplicationString['footer.text']}</p>
      </div>
    </div>
  );
};

export default Footer;
